import {formDataRequest, getRequest, postRequest} from '../libs/AxiosService.util';

export async function serviceGetIncentiveReportEarlyBird(params) {
    return await postRequest('sales/incentive/report', params);
}
export async function serviceGetIncentiveReportRupeeValue(params) {
    return await postRequest('sales/incentive/rupee/incentive/report', params);
}
export async function serviceGetIncentiveReportProduct(params) {
    return await postRequest('sales/incentive/product/incentive/report', params);
}
export async function serviceGetIncentiveReportOverall(params) {
    return await postRequest('sales/incentive/overall/incentive/report', params);
}
export async function serviceIncentiveReportEarlyBirdExport(params) {
    return await postRequest('sales/incentive/early/bird/export', params);
}
export async function serviceIncentiveReportRupeeValueExport(params) {
    return await postRequest('sales/incentive/rupee/incentive/export', params);
}
export async function serviceIncentiveReportProductExport(params) {
    return await postRequest('sales/incentive/product/incentive/export', params);
}
export async function serviceIncentiveReportOverallExport(params) {
    return await postRequest('sales/incentive/overall/incentive/export', params);
}
